<template>
  <div id="afdc-ev-level-help" v-bind:class="{ 'afdc-mobile-ev-help': isMobileView }" v-on-clickaway="closeEvHelp">
    <div id="afdc-ev-level-help-closer" v-on:click="closeEvHelp"><span class="afdc-sr-only">{{ $t('Close') }}</span><font-awesome-icon icon="times-circle" class="afdc-fa-icon"/></div>

    <div class="afdc-row afdc-clearboth">
      <div class="afdc-col-xl-2">
        <strong>{{ $t("Level 1") }}</strong>
      </div>
      <div class="afdc-col-xl-10">
        <p>{{ level1Text }}</p>

        <div class="afdc-d-flex afdc-flex-row afdc-align-items-center afdc-justify-content-center afdc-flex-wrap">
          <div class="afdc-ev-connector afdc-d-flex afdc-align-items-center">
            <img src="../assets/images/level-1-2.png">
            <div>{{ $t("J1772") }}</div>
          </div>
        </div>
      </div>
    </div>

    <hr class="afdc-ev-level-rule">

    <div class="afdc-row">
      <div class="afdc-col-xl-2">
        <strong>{{ $t("Level 2") }}</strong>
      </div>
      <div class="afdc-col-xl-10">
        <p>{{ level2Text }}</p>

        <div class="afdc-d-flex afdc-flex-row afdc-align-items-center afdc-justify-content-center afdc-flex-wrap">
          <div class="afdc-ev-connector afdc-d-flex afdc-align-items-center">
            <img src="../assets/images/level-1-2.png">
            <div>{{ $t("J1772") }}</div>
          </div>
          <div class="afdc-ev-connector afdc-d-flex afdc-align-items-center">
            <img src="../assets/images/dc-tesla.png">
            <div>{{ $t("NACS") }}</div>
          </div>
        </div>
      </div>
    </div>

    <hr class="afdc-ev-level-rule">

    <div class="afdc-row">
      <div class="afdc-col-xl-2">
        <strong>{{ $t("DC Fast") }}</strong>
      </div>
      <div class="afdc-col-xl-10">
        <p>{{ dcFastText }}</p>

        <div class="afdc-d-flex afdc-flex-row afdc-align-items-center afdc-justify-content-center afdc-flex-wrap">
          <div class="afdc-ev-connector afdc-d-flex afdc-align-items-center">
            <img src="../assets/images/dc-sae.png">
            <div>{{ $t("SAE CCS") }}</div>
          </div>

          <div class="afdc-ev-connector afdc-d-flex afdc-align-items-center">
            <img src="../assets/images/dc-chademo.png">
            <div>{{ $t("CHAdeMO") }}</div>
          </div>

          <div class="afdc-ev-connector afdc-d-flex afdc-align-items-center">
            <img src="../assets/images/dc-tesla.png">
            <div>{{ $t("NACS") }}</div>
          </div>
        </div>
      </div>
    </div>

    <hr class="afdc-ev-level-rule">

    <div v-html="$sprintf($t('For more information about charger types and connectors, see <a href=\'%s\'>charging equipment for electric vehicles</a>.'), 'https://afdc.energy.gov/fuels/electricity_stations.html#connectors')"></div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'EvLevelHelp',

  mixins: [
    clickaway,
  ],

  computed: {
    level1Text() {
      if (this.$store.getters.localeCountry === 'CA') {
        return this.$t('Level 1 charging is a 120V standard wall plug using a J1772 connector. Provides approximately 8 kilometers of range per 1 hour of charging (assuming 1.9 kW charging power).');
      }
      return this.$t('Level 1 charging is a 120V standard wall plug using a J1772 connector. Provides approximately 5 miles of range per 1 hour of charging (assuming 1.9 kW charging power).');
    },

    level2Text() {
      if (this.$store.getters.localeCountry === 'CA') {
        return this.$t('Level 2 charging uses 240V/208V for residential or commercial charging using a J1772 or NACS connector. Provides approximately 40 kilometers of range per 1 hour of charging (assuming 6.6 kW charging power).');
      }
      return this.$t('Level 2 charging uses 240V/208V for residential or commercial charging using a J1772 or NACS connector. Provides approximately 25 miles of range per 1 hour of charging (assuming 6.6 kW charging power).');
    },

    dcFastText() {
      if (this.$store.getters.localeCountry === 'CA') {
        return this.$t('There are three types of DC fast charging systems depending on the type of charge port on the vehicle. Provides approximately 160 to 320 kilometers of range per 30 minutes of charging (varying by vehicle and battery state of charge).');
      }
      return this.$t('There are three types of DC fast charging systems depending on the type of charge port on the vehicle. Provides approximately 100 to 200+ miles of range per 30 minutes of charging (varying by vehicle and battery state of charge).');
    },

    isMobileView() {
      return this.$store.getters.isMobileView;
    },
  },

  mounted() {
    this.$nextTick(() => {
      if (this.$store.getters.isMobileView) {
        document.querySelector('.afdc-mobile-ev-help').style.height = `${window.innerHeight - 110}px`;
      }
    });
  },

  methods: {
    closeEvHelp() {
      if (!this.$store.getters.getEvHelpClicked) {
        document.getElementById('afdc-ev-level-help').style.display = 'none';
      }

      this.$store.commit('setEvHelpClicked', false);
    },
  },
};
</script>

<style lang="scss">
@import '~bootstrap/scss/_functions.scss';
@import '~bootstrap/scss/_variables.scss';
@import '~bootstrap/scss/_mixins.scss';

#ev-level-help {
  display: none;
  position: absolute;
  right: 0;
  z-index: 21;
  height: auto;
  overflow: auto;
  background-color: #f4f9f5;
  border: 1px solid #999;
  padding: 20px;
  width: 95%;
  max-width: 625px;
  img {
    float: left;
    width: 50px;
    margin: 0 5px 10px 0;
  }
  hr.ev-level-rule {
    margin-top: 0;
    margin-bottom: 10px;
  }
  .ev-connector {
    width: 150px;
    font-size: 14px;
  }
  #ev-level-help-closer {
    float: right;
    margin: -10px -5px -10px 5px;
    color: #999;
    font-size: 25px;
    &:hover {
      color: #666;
      cursor: pointer;
    }
  }
}

 .mobile-ev-help {
    position: absolute;
    right: 10px !important;
  }
</style>
